export default "__VITE_ASSET__DiZRNnuk__"